module.exports = __webpack_public_path__ + "media/images/flags/gw-f29eedfe431a60cae11edef68d978860.svg";